<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR_ID')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldUserId"
              v-model="objUserMaster.userId"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LOGIN_ID')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldLoginId"
              v-model="objUserMaster.loginId"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EPID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.epid"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EPNO')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.employeeIDNumber"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_KNOX_ID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.knoxId"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR_NM')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldUserName"
              v-model="objUserMaster.userName"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_GLBL_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.userGlobalName"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EMAIL')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.email"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_CD')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.companyCode"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.companyName"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_EN_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.companyEnglishName"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEPT_ID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.departmentId"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEPT_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.departmentName"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEPT_EN_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.departmentEnglishName"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CRLV_CD')" />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              :selected="code.careerLevelCode"
              :initialSelectedIndex="0"
              :option-list="customOptions.careerLevelCode"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CRLV_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.careerLevelName"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CRLV_EN_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.careerLevelEnglishName"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CP')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.cellphone"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_CONTA')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.companyContactAddr"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PBLC_ID_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="objUserMaster.publicIdYn"
              value="Y"
            >
              {{ 'Yes' }}
            </sui-radio>
            <sui-radio
              v-model="objUserMaster.publicIdYn"
              value="N"
            >
              {{ 'No' }}
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EMPL_INFO_FNL_CHG_DT')" />
          </div>
          <div class="col-xs-5">
            <sui-date-picker
              v-model="formatted.empInfoFinalChangeDT"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_REAL_USE_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="objUserMaster.userRealityUseYn"
              value="Y"
            >
              {{ 'Yes' }}
            </sui-radio>
            <sui-radio
              v-model="objUserMaster.userRealityUseYn"
              value="N"
            >
              {{ 'No' }}
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_TYPE_CD')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectUserTypeCode"
              :selected="code.userTypeCode"
              codeId="COD_USR_TYPE"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_BLNG_TYPE_CD')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectUserBelongingTypeCode"
              :selected="code.userBelongingTypeCode"
              codeId="COD_USR_BLNG_TYPE"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_IRSD_STT_CD')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectServedStateCode"
              :selected="code.servedStateCode"
              codeId="COD_IRSD_STT"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DSPL_LNG_ID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="objUserMaster.displayLangId"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onListClick"
        >
          {{ $t("MSG_BTN_LIST") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSaveClick"
        >
          {{ $t("MSG_BTN_SAVE") }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00034', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      queryData: {},
      code: {
        careerLevelCode: { key: '', label: '' },
        userTypeCode: { key: '', label: '' },
        userBelongingTypeCode: { key: '', label: '' },
        servedStateCode: { key: '', label: '' },
      },
      formatted: {
        empInfoFinalChangeDT: '',
      },
      customOptions: {
        careerLevelCode: [],
      },
      objUserMaster: {
        userId: '',
        loginId: '',
        epid: '',
        employeeIDNumber: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        email: '',
        companyCode: '',
        companyName: '',
        companyEnglishName: '',
        departmentId: '',
        departmentName: '',
        departmentEnglishName: '',
        careerLevelCode: '',
        careerLevelName: '',
        careerLevelEnglishName: '',
        cellphone: '',
        companyContactAddr: '',
        publicIdYn: '',
        empInfoFinalChangeDT: '',
        userRealityUseYn: '',
        userTypeCode: '',
        userBelongingTypeCode: '',
        servedStateCode: '',
        displayLangId: '',
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.queryData = utils.getParameter(this, 'queryData');
      this.loadCustomOptionsCareerLevelCode();
    },
    loadCustomOptionsCareerLevelCode() {
      /* sample code for custom select
        http.request(this.contextPageId, 'DTS_CMA_00039', {
        }).then(res => {
            if (res.data.length > 0) {
                this.customOptions.careerLevelCode = [];
                utils.forEach(res.data, obj => {
                    const options = {
                        key: obj.siteId,
                        label: obj.siteName,
                    };
                    this.customOptions.careerLevelCode.push(options);
                });
            }
        });
        */
    },
    onListClick() {
      utils.goPage('PGE_CMY_00033', {
        queryData: this.queryData,
      });
    },
    onSaveClick() {
      if (utils.isEmpty(this.objUserMaster.userId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_USR_ID')), null, () => {
          this.$refs.textFieldUserId.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.objUserMaster.loginId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_LOGIN_ID')), null, () => {
          this.$refs.textFieldLoginId.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.objUserMaster.userName)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_USR_NM')), null, () => {
          this.$refs.textFieldUserName.setFocus();
        });
        return false;
      }
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        this.objUserMaster.careerLevelCode = this.code.careerLevelCode.key;
        this.objUserMaster.userTypeCode = this.code.userTypeCode.key;
        this.objUserMaster.userBelongingTypeCode = this.code.userBelongingTypeCode.key;
        this.objUserMaster.servedStateCode = this.code.servedStateCode.key;
        this.objUserMaster.empInfoFinalChangeDT = utils.dateformatToServer(this.formatted.empInfoFinalChangeDT, 'S');

        http.requestTest('post', '/api/v1/common/user-master', {
          // http.request(this.contextPageId, "DTS_XXX_XXXXX", {
          data: this.objUserMaster,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
